import React from "react"

import { getThemeColor } from "./utils"
import Typography from "../../../elements/V2/Typography"

type BulletListCellProps = {
  items: string[]
  theme: "light" | "dark"
}

const BulletListCell = ({ items, theme }: BulletListCellProps) => (
  <div className="flex flex-col gap-0.5 text-start">
    {items.map((item, index) => (
      <Typography
        text={`• ${item}`}
        size="body-md"
        font="grotesk"
        weight="book"
        color={getThemeColor(theme)}
        key={`bullet-${item}-${index}`}
      />
    ))}
  </div>
)

export default BulletListCell
